import React from 'react'
import { useIntl } from 'react-intl'
import studentBlazon from 'shared/assets/images/student-blazon/studentBlazon.jpg'
import styled from 'styled-components'
import { StudentForm } from './components/StudentForm'
import { Spacer } from 'app-v2/design-systems'
import { H5 } from 'app/common/typography'
import { Text } from 'app/common/typography'
import { useSelector } from 'react-redux'
import { studentRegistrationStates } from 'shared/utils'

type StudentCardProps = {
    formik: any
}

export const StudentCard = ({ formik }: StudentCardProps) => {
    const intl = useIntl()
    const { studentRegistrationState } = useSelector(
        state => state.kingdomProfilePageState
    )
    const isProfileAlreadyValidated = [
        studentRegistrationStates.VALIDATED,
        studentRegistrationStates.OLD_LOCAL
    ].includes(studentRegistrationState)

    return (
        <div>
            <StyledImageContainer>
                <StyledImage src={studentBlazon} />
            </StyledImageContainer>

            <Spacer />

            {isProfileAlreadyValidated ? (
                <StyledHeaderContainer>
                    <Text>
                        {intl.formatMessage({
                            id:
                                studentRegistrationState ===
                                studentRegistrationStates.OLD_LOCAL
                                    ? 'kingdom.profile.form.student.activate.profile.local.activated'
                                    : 'kingdom.profile.form.student.activate.profile.activated'
                        })}
                    </Text>
                </StyledHeaderContainer>
            ) : (
                <>
                    <StyledHeaderContainer>
                        <H5>
                            {intl.formatMessage({
                                id:
                                    'kingdom.profile.form.student.activate.profile'
                            })}
                        </H5>
                    </StyledHeaderContainer>

                    <Spacer />

                    <Text>
                        {intl.formatMessage({
                            id:
                                'kingdom.profile.form.student.activate.profile.description'
                        })}
                    </Text>

                    <StudentForm
                        formik={formik}
                        isProfileAlreadyValidated={isProfileAlreadyValidated}
                    />
                </>
            )}
        </div>
    )
}

const StyledImageContainer = styled.div`
    display: flex;
    width: 100%;
    justify-content: center;
    align-items: center;
`

const StyledImage = styled.img`
    height: 100%;
    max-height: 200px;
    max-width: 500px;
    width: 100%;
    resize-mode: contain;
`
const StyledHeaderContainer = styled.div`
    display: flex;
    align-items: center;
    flex-direction: row;
    width: 100%;
    justify-content: space-between;
`
